import globalTime from "./globalTime.mjs";
class VirtualContext {
  constructor(id, players, type) {
    this.id = id;
    this.players = players;
    this.type = type;
  }
  static single(player, ownId) {
    const contextId = "player:" + (ownId ? [player.id, ownId].sort().join(",") : player.id);
    return new VirtualContext(contextId, [player], "SINGLE");
  }
  static group(players, groupID) {
    return new VirtualContext("group:" + groupID, players, "GROUP");
  }
  static squad(squadId) {
    return new VirtualContext("squad:" + squadId, [], "SQUAD");
  }
  static tournament(id) {
    const contextId = id ? id : "" + Math.floor(globalTime.getNow() / 1e3 / 3600);
    return new VirtualContext("tournament:" + contextId, [], "TOURNAMENT");
  }
}
export {
  VirtualContext
};
